import ImageCarousel from './ImageCarousel';
import UspTag from './UspTag';
import { ProductImageContainerProps } from '../types';

/**
 * ProductImageContainer - Wrapper component combining image carousel
 *
 * **Features:**
 * - Combines ImageCarousel with hover state management
 * - Passes hover state to carousel for initialization
 * - Displays USP tags in top-left corner of image
 */
const ProductImageContainer = ({ images, title, isCardHovered = false, isNotInteractive = false, uspTags }: ProductImageContainerProps) => {
  return (
    <div className="relative w-full">
      <ImageCarousel
        images={Array.isArray(images) ? images : []}
        title={title}
        isCardHovered={isCardHovered}
        isNotInteractive={isNotInteractive}
      />
      
      {/* USP Tags - positioned in top-left corner */}
      {uspTags && uspTags.length > 0 && (
        <div className="absolute top-3 left-3 z-20">
          <UspTag
            tagName={uspTags[0].tagName}
            templateName={uspTags[0].templateName}
          />
        </div>
      )}
    </div>
  );
};

export default ProductImageContainer; 